import React, { Fragment } from 'react'

import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import TriggerCallsLoader from './_load/TriggerCallsLoader'
import TriggerCallsTable from './table/TriggerCallsTable'

const PageContent = () => {
  return (
    <Fragment>
      <ControlBar />

      <MultiSelectHandler>
        <TriggerCallsLoader uncontrolledChildren={<MultiRowsActions />}>
          <TriggerCallsTable />
        </TriggerCallsLoader>
      </MultiSelectHandler>
    </Fragment>
  )
}

export default PageContent
